import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import './Dashboard.css'; 
import { api, ApiError } from './api';
import { EstadoError } from './EstadoError';
import { categoriaEstaRegistrada, construirOpcionesCategorias } from './categoriasProducto';

// 🚀 RECEPTOR DEL PUENTE: Ahora Inventario recibe el filtroExterno desde App.js
export default function Inventario({ filtroExterno, setFiltroExterno }) {
  const notificarProductosActualizados = () => {
    window.dispatchEvent(new CustomEvent('productos-actualizados'));
  };
  const [pestaña, setPestaña] = useState('productos'); 
  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [errorCarga, setErrorCarga] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [categoriaFiltro, setCategoriaFiltro] = useState(''); 

  const [mostrarModalProd, setMostrarModalProd] = useState(false);
  const [modalAumento, setModalAumento] = useState(false);
  const [modalImportar, setModalImportar] = useState(false);

  const [prodForm, setProdForm] = useState({ id: null, codigo_barras: '', codigos_barras_text: '', descripcion: '', precio_costo: '', porcentaje_ganancia: '', precio_venta: '', stock_minimo: '', stock_maximo: '', dias_reposicion: 7, cantidad_stock: '', categoria: 'General', marca: '', acepta_fraccion: false, unidad_medida: 'unidad', contenido_unidades: 1, unidad_base: 'unidad', iva_tratamiento: 'gravado', iva_alicuota: 21 });
  const [catForm, setCatForm] = useState({ id: null, nombre: '', descripcion: '' });
  const [formAumento, setFormAumento] = useState({ porcentaje: '', categoria: '', redondeo: '0' });
  const [datosImportacion, setDatosImportacion] = useState([]);

  const opcionesCategorias = construirOpcionesCategorias(categorias, productos, prodForm.categoria);
  const categoriaActualRegistrada = categoriaEstaRegistrada(categorias, prodForm.categoria);

  const cargarDatos = async () => {
    setErrorCarga('');
    try {
      const [dataProd, dataCat] = await Promise.all([
        api.get('/api/productos'),
        api.get('/api/categorias'),
      ]);
      setProductos(Array.isArray(dataProd) ? dataProd : []);
      setCategorias(Array.isArray(dataCat) ? dataCat : []);
    } catch (err) {
      setErrorCarga(err instanceof ApiError ? err.mensaje : 'No se pudo cargar el inventario.');
    }
  };

  useEffect(() => { cargarDatos(); }, []);

  // Si cambiamos de pestaña (ej: a rubros), limpiamos el filtro del dashboard
  useEffect(() => {
    if (pestaña !== 'productos' && setFiltroExterno) {
        setFiltroExterno('todos');
    }
  }, [pestaña, setFiltroExterno]);

  const limpiarBase = async () => {
    if (!window.confirm("⚠️ ¿Eliminar los productos basura con precio $0 o incompletos? Esto limpiará la lista.")) return;
    try {
      const data = await api.post('/api/productos/limpiar');
      if (data.success) { alert(`✅ Limpieza exitosa. Se borraron ${data.borrados} registros basura.`); cargarDatos(); }
    } catch (err) {
      alert("❌ " + (err instanceof ApiError ? err.mensaje : 'Error al limpiar.'));
    }
  };

  const guardarCategoria = async () => {
    if (!catForm.nombre) return alert("El nombre es obligatorio");
    try {
      // ANTES: el endpoint POST /api/categorias NO EXISTÍA en el backend.
      // El "Guardar Rubro" fallaba en silencio porque el fetch no chequeaba
      // response.ok y el alert decía "Guardado" igual. Ahora el backend
      // tiene el endpoint y api.js detecta el error de verdad.
      if (catForm.id) {
        await api.put(`/api/categorias/${catForm.id}`, catForm);
      } else {
        await api.post('/api/categorias', catForm);
      }
      alert("✅ Rubro Guardado"); setCatForm({ id: null, nombre: '', descripcion: '' }); cargarDatos();
    } catch (err) {
      alert("❌ " + (err instanceof ApiError ? err.mensaje : 'Error al guardar rubro.'));
    }
  };

  const manejarCambioProd = (e) => {
    const { name, value, type, checked } = e.target;
    const valor = type === 'checkbox' ? checked : value;
    let nuevoForm = { ...prodForm, [name]: valor };
    if (name === 'unidad_medida') {
      nuevoForm.acepta_fraccion = ['kg', 'litro', 'metro'].includes(value);
    }
    if (name === 'iva_tratamiento') {
      if (value === 'exento') nuevoForm.iva_alicuota = 0;
      if (value === 'gravado' && prodForm.iva_tratamiento === 'exento') nuevoForm.iva_alicuota = 21;
    }
    if (name === 'precio_costo' || name === 'porcentaje_ganancia') {
      const c = parseFloat(nuevoForm.precio_costo) || 0;
      const p = parseFloat(nuevoForm.porcentaje_ganancia) || 0;
      nuevoForm.precio_venta = (c + (c * (p / 100))).toFixed(2);
    }
    setProdForm(nuevoForm);
  };

  const guardarProducto = async () => {
    if (!prodForm.descripcion || !prodForm.precio_venta) return alert("Faltan datos clave");
    if (!categoriaEstaRegistrada(categorias, prodForm.categoria)) {
      return alert(`La categoría "${prodForm.categoria || 'sin nombre'}" ya no está registrada. Elegí una categoría vigente antes de guardar.`);
    }
    try {
      const payload = {
        ...prodForm,
        codigos_barras: String(prodForm.codigos_barras_text || '')
          .split(/[,;\n]/).map(x => x.trim()).filter(Boolean),
      };
      if (prodForm.id) {
        await api.put(`/api/productos/${prodForm.id}`, payload);
      } else {
        await api.post('/api/productos', payload);
      }
      setMostrarModalProd(false); await cargarDatos(); notificarProductosActualizados();
    } catch (err) {
      alert("❌ " + (err instanceof ApiError ? err.mensaje : 'Error al guardar.'));
    }
  };

  const descargarArchivo = async (path, nombreArchivo) => {
    try {
      const blob = await api.download(path);
      const url = window.URL.createObjectURL(blob);
      const enlace = document.createElement('a');
      enlace.href = url;
      enlace.download = nombreArchivo;
      document.body.appendChild(enlace);
      enlace.click();
      enlace.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("❌ " + (err instanceof ApiError ? err.mensaje : 'No se pudo descargar el archivo.'));
    }
  };

  const exportarExcel = () => {
    const fecha = new Date().toISOString().slice(0, 10);
    descargarArchivo('/api/productos/exportar/excel', `Inventario_${fecha}.xlsx`);
  };

  const exportarPDF = () => {
    const fecha = new Date().toISOString().slice(0, 10);
    descargarArchivo('/api/productos/exportar/pdf', `Inventario_${fecha}.pdf`);
  };

  const aplicarAumentoMasivo = async () => {
    if (!formAumento.porcentaje) return alert("Ingresá un porcentaje");
    try {
      await api.post('/api/productos/aumento-masivo', formAumento);
      alert("✅ Aumento masivo aplicado."); setModalAumento(false); await cargarDatos(); notificarProductosActualizados();
    } catch (err) {
      alert("❌ " + (err instanceof ApiError ? err.mensaje : 'Error al aplicar aumento masivo.'));
    }
  };

  const leerExcelImportacion = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const buffer = evt.target.result;
        const wb = XLSX.read(buffer, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws);
        if (data.length === 0) return alert("❌ El Excel está vacío.");

        const preview = data.map(row => {
          const codigo = row.codigo_barras ?? row.Codigo ?? row.codigo ?? row['Código'] ?? '';
          const codigoNormalizado = String(codigo).trim();
          const existe = codigoNormalizado
            ? productos.find(p => String(p.codigo_barras ?? '').trim() === codigoNormalizado || (Array.isArray(p.codigos_barras) && p.codigos_barras.some(c => String(c).trim() === codigoNormalizado)))
            : null;
          const catExcel = row.categoria ?? row.Categoria ?? row.Rubro ?? row.rubro ?? 'General';
          const stockRaw =
            row.cantidad_stock ?? row.Stock ?? row.stock ?? row.Existencia ??
            row.existencia ?? row.Cantidad ?? row.cantidad;
          const stockMinimoRaw =
            row.stock_minimo ?? row['Stock Minimo'] ?? row['Stock Mínimo'] ??
            row.StockMinimo ?? row.stockMinimo;

          const stockNumerico = stockRaw === undefined || stockRaw === null || stockRaw === ''
            ? null
            : Number.parseFloat(stockRaw);
          const stockMinimoNumerico = stockMinimoRaw === undefined || stockMinimoRaw === null || stockMinimoRaw === ''
            ? null
            : Number.parseFloat(stockMinimoRaw);

          const stockMaximoRaw = row.stock_maximo ?? row['Stock Maximo'] ?? row['Stock Máximo'] ?? row.StockMaximo ?? row.stockMaximo;
          const diasReposicionRaw = row.dias_reposicion ?? row['Dias Reposicion'] ?? row['Días Reposición'] ?? row.DiasReposicion;
          const stockMaximoNumerico = stockMaximoRaw === undefined || stockMaximoRaw === null || stockMaximoRaw === ''
            ? null : Number.parseFloat(stockMaximoRaw);
          const diasReposicionNumerico = diasReposicionRaw === undefined || diasReposicionRaw === null || diasReposicionRaw === ''
            ? null : Number.parseInt(diasReposicionRaw, 10);

          return {
            codigo_barras: String(codigo).trim(),
            codigos_barras: String(row.codigos_barras ?? row['Todos los códigos'] ?? row['Codigos alternativos'] ?? '').split(/[,;\n]/).map(x => x.trim()).filter(Boolean),
            descripcion: String(row.descripcion ?? row.Descripcion ?? row['Descripción'] ?? row.Nombre ?? row.nombre ?? 'Sin Nombre').trim(),
            costo: Number.parseFloat(row.costo ?? row.Costo ?? row.precio_costo ?? 0) || 0,
            precio_venta: Number.parseFloat(row.precio_venta ?? row.Precio ?? row.precio ?? 0) || 0,
            cantidad_stock: Number.isFinite(stockNumerico) ? stockNumerico : null,
            stock_minimo: Number.isFinite(stockMinimoNumerico) ? stockMinimoNumerico : null,
            stock_maximo: Number.isFinite(stockMaximoNumerico) ? stockMaximoNumerico : null,
            dias_reposicion: Number.isInteger(diasReposicionNumerico) ? diasReposicionNumerico : null,
            unidad_medida: String(row.unidad_medida ?? row.Unidad ?? row.unidad ?? 'unidad').trim().toLowerCase(),
            contenido_unidades: Number.parseFloat(row.contenido_unidades ?? row['Contenido por caja/pack'] ?? 1) || 1,
            unidad_base: String(row.unidad_base ?? row['Unidad base'] ?? 'unidad').trim().toLowerCase(),
            acepta_fraccion: ['true', 'si', 'sí', '1', 'kg', 'kilo', 'kilogramo', 'litro', 'metro'].includes(String(row.acepta_fraccion ?? row.Fraccionable ?? row.fraccionable ?? row.Unidad ?? '').trim().toLowerCase()),
            iva_tratamiento: String(row.iva_tratamiento ?? row['Tratamiento IVA'] ?? row.TratamientoIVA ?? '').trim().toLowerCase().includes('exent') ? 'exento' : 'gravado',
            iva_alicuota: Number.parseFloat(row.iva_alicuota ?? row['Alícuota IVA'] ?? row['Alicuota IVA'] ?? row.IVA ?? 21) || 0,
            categoria: String(catExcel || 'General').trim(),
            marca: String(row.marca ?? row.Marca ?? row.brand ?? row.Brand ?? '').trim(),
            categoria_original: String(catExcel || 'General').trim(),
            accion: existe ? 'Actualizar' : 'Crear'
          };
        });
        setDatosImportacion(preview); setModalImportar(true);
      } catch (error) { alert("❌ Error al procesar el Excel."); }
    };
    reader.readAsArrayBuffer(file); e.target.value = null;
  };

  const confirmarImportacion = async () => {
    try {
      await api.post('/api/productos/importar', { items: datosImportacion });
      alert("✅ Importación exitosa."); setModalImportar(false); setDatosImportacion([]); await cargarDatos(); notificarProductosActualizados();
    } catch (err) {
      alert("❌ " + (err instanceof ApiError ? err.mensaje : 'Error al importar.'));
    }
  };

  if (errorCarga) {
    return <EstadoError mensaje={errorCarga} onReintentar={cargarDatos} />;
  }

  // 🚀 LÓGICA DE FILTRADO COMBINADO (Búsqueda + Categoría + Alerta del Dashboard)
  const prodFiltrados = productos.filter(p => {
    const codigosProducto = Array.isArray(p.codigos_barras) ? p.codigos_barras.join(' ') : '';
    const termino = busqueda.toLowerCase();
    const cumpleBusqueda = (p.descripcion || '').toLowerCase().includes(termino) || (p.marca || '').toLowerCase().includes(termino) || (p.codigo_barras && p.codigo_barras.includes(busqueda)) || codigosProducto.includes(busqueda);
    const cumpleCategoria = categoriaFiltro === '' || p.categoria === categoriaFiltro;
    
    let cumpleExterno = true;
    if (filtroExterno === 'bajo') {
      cumpleExterno = parseFloat(p.cantidad_stock) <= parseFloat(p.stock_minimo) && parseFloat(p.cantidad_stock) > 0;
    } else if (filtroExterno === 'negativo') {
      cumpleExterno = parseFloat(p.cantidad_stock) <= 0;
    } else if (filtroExterno === 'sin_precio') {
      cumpleExterno = parseFloat(p.precio_venta) <= 0;
    }

    return cumpleBusqueda && cumpleCategoria && cumpleExterno;
  });
  
  return (
    <div className="dash-container">
      <div><h2 style={{ margin: 0, color: '#0f172a', fontSize: '24px' }}>Gestión de Inventario</h2></div>

      <div style={{ display: 'flex', gap: '10px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', marginTop: '20px' }}>
        <button onClick={() => setPestaña('productos')} style={{ ...tabStyle, borderBottom: pestaña === 'productos' ? '3px solid #3b82f6' : 'none', fontWeight: pestaña === 'productos' ? 'bold' : 'normal' }}>📦 Base de Productos</button>
        <button onClick={() => setPestaña('categorias')} style={{ ...tabStyle, borderBottom: pestaña === 'categorias' ? '3px solid #8b5cf6' : 'none', fontWeight: pestaña === 'categorias' ? 'bold' : 'normal' }}>🏷️ Rubros / Categorías</button>
      </div>

      {pestaña === 'productos' && (
        <div className="card-panel">
          <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginBottom: '20px', backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => { setProdForm({ id: null, codigo_barras: '', codigos_barras_text: '', descripcion: '', precio_costo: '', porcentaje_ganancia: '', precio_venta: '', stock_minimo: '', stock_maximo: '', dias_reposicion: 7, cantidad_stock: '', categoria: categorias[0]?.nombre || 'General', marca: '', acepta_fraccion: false, unidad_medida: 'unidad', contenido_unidades: 1, unidad_base: 'unidad', iva_tratamiento: 'gravado', iva_alicuota: 21 }); setMostrarModalProd(true); }} style={{ backgroundColor: '#3b82f6', color: 'white', padding: '10px 15px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}>➕ Nuevo Producto</button>
              <button onClick={() => { setFormAumento({ porcentaje: '', categoria: categoriaFiltro, redondeo: '0' }); setModalAumento(true); }} style={{ backgroundColor: '#f59e0b', color: 'white', padding: '10px 15px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}>📈 Aumento de Precios</button>
              <button onClick={limpiarBase} style={{ backgroundColor: '#ef4444', color: 'white', padding: '10px 15px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}>🧹 Limpiar Errores</button>
            </div>
            
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <label style={{ backgroundColor: '#10b981', color: 'white', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', margin: 0 }}>
                📥 Importar Excel
                <input type="file" accept=".xlsx" style={{ display: 'none' }} onChange={leerExcelImportacion} />
              </label>
              <button onClick={exportarExcel} style={{ backgroundColor: '#0ea5e9', color: 'white', padding: '10px 15px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}>📊 Bajar Excel</button>
              <button onClick={exportarPDF} style={{ backgroundColor: '#475569', color: 'white', padding: '10px 15px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}>📄 Bajar PDF</button>
            </div>
          </div>

          {/* 🚀 EL AVISO AMARILLO SI HAY UN FILTRO EXTERNO ACTIVADO */}
          {filtroExterno && filtroExterno !== 'todos' && (
            <div style={{ backgroundColor: '#fffbeb', border: '1px solid #fde047', padding: '12px 20px', borderRadius: '8px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#d97706', fontWeight: 'bold', fontSize: '15px' }}>
                ⚠️ Filtro del Dashboard Activado: Mostrando productos con {filtroExterno === 'bajo' ? 'Stock Bajo' : filtroExterno === 'negativo' ? 'Stock Crítico (0 o menos)' : 'Precio Cero ($0)'}
              </span>
              <button onClick={() => setFiltroExterno && setFiltroExterno('todos')} style={{ backgroundColor: '#fef3c7', color: '#b45309', border: '1px solid #fcd34d', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
                ❌ Quitar este filtro
              </button>
            </div>
          )}

          <div style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>
            <input type="text" placeholder="🔍 Buscar por nombre, marca o código de barras..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ flex: 2, padding: '12px 15px', borderRadius: '8px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }} />
            <select value={categoriaFiltro} onChange={e => setCategoriaFiltro(e.target.value)} style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', backgroundColor: 'white' }}>
              <option value="">-- Filtrar por Rubro (Todos) --</option>
              {construirOpcionesCategorias(categorias, productos).map(c => <option key={c.nombre.toLowerCase()} value={c.nombre}>{c.nombre}{c.registrada ? '' : ' (no registrada)'}</option>)}
            </select>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table className="table-modern">
              <thead><tr><th>Código</th><th>Descripción</th><th>Marca</th><th>Categoría</th><th style={{textAlign:'right'}}>Costo</th><th style={{textAlign:'right'}}>P. Venta</th><th style={{textAlign:'center'}}>Stock</th><th style={{textAlign:'center'}}>Acciones</th></tr></thead>
              <tbody>
                {prodFiltrados.map(p => (
                  <tr key={p.id}>
                    <td style={{ color: '#64748b' }}>{p.codigo_barras || '-'}</td>
                    <td style={{ fontWeight: '600', color: '#0f172a' }}>{p.descripcion}</td>
                    <td>{p.marca || '-'}</td>
                    <td>
                      <Badge
                        bg={p.categoria_registrada === false ? '#fff7ed' : '#f1f5f9'}
                        color={p.categoria_registrada === false ? '#c2410c' : '#475569'}
                      >
                        {p.categoria || 'General'}{p.categoria_registrada === false ? ' ⚠' : ''}
                      </Badge>
                    </td>
                    <td style={{ textAlign: 'right' }}>${(parseFloat(p.precio_costo) || 0).toFixed(2)}</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold', color: '#10b981' }}>${(parseFloat(p.precio_venta) || 0).toFixed(2)}</td>
                    <td style={{ textAlign: 'center' }}><span style={{ backgroundColor: parseFloat(p.cantidad_stock) <= parseFloat(p.stock_minimo) ? '#fef2f2' : '#f0fdf4', color: parseFloat(p.cantidad_stock) <= parseFloat(p.stock_minimo) ? '#ef4444' : '#15803d', padding: '4px 8px', borderRadius: '6px', fontWeight: 'bold' }}>{(parseFloat(p.cantidad_stock) || 0).toLocaleString('es-AR', { maximumFractionDigits: 3 })} {p.unidad_medida === 'unidad' ? 'u.' : p.unidad_medida}</span></td>
                    <td style={{ textAlign: 'center' }}><button onClick={() => { setProdForm({ id: p.id, codigo_barras: p.codigo_barras || '', codigos_barras_text: (Array.isArray(p.codigos_barras) ? p.codigos_barras.filter(c => c !== p.codigo_barras) : []).join(', '), descripcion: p.descripcion, precio_costo: p.precio_costo || 0, porcentaje_ganancia: p.porcentaje_ganancia || 0, precio_venta: p.precio_venta, stock_minimo: p.stock_minimo, stock_maximo: p.stock_maximo ?? '', dias_reposicion: p.dias_reposicion ?? 7, cantidad_stock: p.cantidad_stock, categoria: p.categoria || 'General', marca: p.marca || '', acepta_fraccion: Boolean(p.acepta_fraccion), unidad_medida: p.unidad_medida || 'unidad', contenido_unidades: p.contenido_unidades || 1, unidad_base: p.unidad_base || 'unidad', iva_tratamiento: p.iva_tratamiento || 'gravado', iva_alicuota: Number(p.iva_alicuota ?? 21) }); setMostrarModalProd(true); }} style={{ backgroundColor: '#f59e0b', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>✏️</button></td>
                  </tr>
                ))}
                {prodFiltrados.length === 0 && (
                  <tr><td colSpan="8" style={{textAlign: 'center', padding: '20px', color: '#94a3b8'}}>No se encontraron productos con el filtro actual.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {pestaña === 'categorias' && (
        <div className="split-grid">
          <div className="card-panel">
            <table className="table-modern">
              <thead><tr><th>Nombre</th><th>Descripción</th><th>Acciones</th></tr></thead>
              <tbody>
                {categorias.map(c => (
                  <tr key={c.id}>
                    <td style={{ fontWeight: 'bold' }}>{c.nombre}</td><td>{c.descripcion || '-'}</td>
                    <td>{c.id !== 1 && <button onClick={() => setCatForm({ id: c.id, nombre: c.nombre, descripcion: c.descripcion || '' })} style={{ backgroundColor: '#f59e0b', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>✏️</button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="card-panel">
            <h3 className="card-title">{catForm.id ? '✏️ Editar Categoría' : '➕ Nueva Categoría'}</h3>
            <label style={labelStyle}>Nombre de Categoría</label><input type="text" value={catForm.nombre} onChange={e => setCatForm({...catForm, nombre: e.target.value})} style={inputStyle} />
            <button onClick={guardarCategoria} style={{ width: '100%', padding: '12px', backgroundColor: catForm.id ? '#f59e0b' : '#8b5cf6', color: 'white', fontWeight: 'bold', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Guardar</button>
          </div>
        </div>
      )}

      {mostrarModalProd && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0 }}>{prodForm.id ? '✏️ Editar Producto' : '📦 Nuevo Producto'}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div><label style={labelStyle}>Código de Barras</label><input type="text" name="codigo_barras" value={prodForm.codigo_barras} onChange={manejarCambioProd} style={inputStyle} /></div>
              <div>
                <label style={labelStyle}>Categoría</label>
                <select name="categoria" value={prodForm.categoria} onChange={manejarCambioProd} style={inputStyle}>
                  {opcionesCategorias.map(c => (
                    <option key={c.nombre.toLowerCase()} value={c.nombre}>
                      {c.nombre}{c.registrada ? '' : ' — no registrada'}
                    </option>
                  ))}
                </select>
                {!categoriaActualRegistrada && (
                  <div style={{ marginTop: '6px', padding: '8px 10px', borderRadius: '6px', background: '#fff7ed', color: '#c2410c', fontSize: '12px', fontWeight: '600' }}>
                    ⚠️ El producto está guardado como “{prodForm.categoria || 'Sin categoría'}”, pero ese rubro ya no existe. Elegí una categoría vigente antes de guardar.
                  </div>
                )}
              </div>
            </div>
            <label style={labelStyle}>Marca (opcional)</label>
            <input type="text" name="marca" maxLength="120" value={prodForm.marca || ''} onChange={manejarCambioProd} style={inputStyle} placeholder="Ej: Coca-Cola, Arcor, La Serenísima" />
            <label style={labelStyle}>Códigos alternativos</label>
            <input type="text" name="codigos_barras_text" value={prodForm.codigos_barras_text} onChange={manejarCambioProd} style={inputStyle} placeholder="Separados por coma: código caja, código proveedor..." />
            <label style={labelStyle}>Descripción</label><input type="text" name="descripcion" value={prodForm.descripcion} onChange={manejarCambioProd} style={inputStyle} />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', backgroundColor: '#f8fafc', padding: '10px', borderRadius: '8px', marginBottom: '15px' }}>
              <div><label style={labelStyle}>Costo ($)</label><input type="number" name="precio_costo" value={prodForm.precio_costo} onChange={manejarCambioProd} style={inputStyle} /></div>
              <div><label style={labelStyle}>Margen (%)</label><input type="number" name="porcentaje_ganancia" value={prodForm.porcentaje_ganancia} onChange={manejarCambioProd} style={inputStyle} /></div>
              <div><label style={{...labelStyle, color: '#10b981'}}>Precio Final ($)</label><input type="number" name="precio_venta" value={prodForm.precio_venta} onChange={manejarCambioProd} style={{...inputStyle, fontWeight: 'bold', color: '#10b981', borderColor: '#10b981'}} /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', backgroundColor: '#fff7ed', padding: '10px', borderRadius: '8px', marginBottom: '15px', border: '1px solid #fed7aa' }}>
              <div>
                <label style={labelStyle}>Tratamiento IVA</label>
                <select name="iva_tratamiento" value={prodForm.iva_tratamiento || 'gravado'} onChange={manejarCambioProd} style={inputStyle}>
                  <option value="gravado">Gravado</option>
                  <option value="exento">Exento</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Alícuota IVA</label>
                <select name="iva_alicuota" value={Number(prodForm.iva_alicuota ?? 21)} onChange={manejarCambioProd} style={inputStyle} disabled={prodForm.iva_tratamiento === 'exento'}>
                  <option value={0}>0%</option>
                  <option value={2.5}>2,5%</option>
                  <option value={5}>5%</option>
                  <option value={10.5}>10,5%</option>
                  <option value={21}>21%</option>
                  <option value={27}>27%</option>
                </select>
                <small style={{ color: '#9a3412' }}>El precio final debe incluir IVA.</small>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
              <div>
                <label style={labelStyle}>Unidad de medida</label>
                <select name="unidad_medida" value={prodForm.unidad_medida} onChange={manejarCambioProd} style={inputStyle}>
                  <option value="unidad">Unidad</option>
                  <option value="kg">Kilogramo (kg)</option>
                  <option value="litro">Litro</option>
                  <option value="metro">Metro</option>
                  <option value="caja">Caja</option>
                  <option value="pack">Pack</option>
                </select>
              </div>
              <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', marginTop: '28px', cursor: 'pointer' }}>
                <input type="checkbox" name="acepta_fraccion" checked={Boolean(prodForm.acepta_fraccion)} onChange={manejarCambioProd} style={{ width: '18px', height: '18px' }} />
                Permitir cantidades fraccionadas
              </label>
            </div>
            {['caja','pack'].includes(prodForm.unidad_medida) && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', background:'#eff6ff', padding:'10px', borderRadius:'8px', marginBottom:'15px' }}>
                <div><label style={labelStyle}>Contenido por {prodForm.unidad_medida}</label><input type="number" min="0.001" step="0.001" name="contenido_unidades" value={prodForm.contenido_unidades} onChange={manejarCambioProd} style={inputStyle} /></div>
                <div><label style={labelStyle}>Unidad base</label><select name="unidad_base" value={prodForm.unidad_base} onChange={manejarCambioProd} style={inputStyle}><option value="unidad">Unidad</option><option value="kg">Kilogramo</option><option value="litro">Litro</option><option value="metro">Metro</option></select></div>
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(145px,1fr))', gap: '15px' }}>
              <div><label style={labelStyle}>Stock actual</label><input type="number" step={prodForm.acepta_fraccion ? '0.001' : '1'} name="cantidad_stock" value={prodForm.cantidad_stock} onChange={manejarCambioProd} style={inputStyle} /></div>
              <div><label style={labelStyle}>Stock mínimo</label><input type="number" min="0" step={prodForm.acepta_fraccion ? '0.001' : '1'} name="stock_minimo" value={prodForm.stock_minimo} onChange={manejarCambioProd} style={inputStyle} /></div>
              <div><label style={labelStyle}>Stock máximo</label><input type="number" min="0" step={prodForm.acepta_fraccion ? '0.001' : '1'} name="stock_maximo" value={prodForm.stock_maximo} onChange={manejarCambioProd} style={inputStyle} /></div>
              <div><label style={labelStyle}>Días de reposición</label><input type="number" min="0" max="3650" step="1" name="dias_reposicion" value={prodForm.dias_reposicion} onChange={manejarCambioProd} style={inputStyle} /></div>
            </div>
            <small style={{ color: '#64748b' }}>La sugerencia de compra considera mínimo, máximo, ventas recientes, mercadería pendiente y días que demora el proveedor.</small>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setMostrarModalProd(false)} style={btnCancelStyle}>Cancelar</button>
              <button onClick={guardarProducto} style={btnSaveStyle}>Guardar Cambios</button>
            </div>
          </div>
        </div>
      )}

      {modalAumento && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0, color: '#f59e0b' }}>📈 Aumento masivo del precio de venta</h3>
            <label style={labelStyle}>Porcentaje de aumento (%)</label>
            <input type="number" value={formAumento.porcentaje} onChange={e => setFormAumento({...formAumento, porcentaje: e.target.value})} style={inputStyle} placeholder="Ej: 15" />
            <label style={labelStyle}>Rubro Específico a Aumentar</label>
            <select value={formAumento.categoria} onChange={e => setFormAumento({...formAumento, categoria: e.target.value})} style={inputStyle}>
              <option value="">-- Todos los Rubros --</option>
              {categorias.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
            </select>
            <label style={labelStyle}>Redondeo de Precios</label>
            <select value={formAumento.redondeo} onChange={e => setFormAumento({...formAumento, redondeo: e.target.value})} style={inputStyle}>
              <option value="0">Sin redondeo (Ej: $145.32)</option>
              <option value="10">Redondear a $10 (Ej: $150.00)</option>
              <option value="50">Redondear a $50 (Ej: $150.00)</option>
              <option value="100">Redondear a $100 (Ej: $200.00)</option>
            </select>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setModalAumento(false)} style={btnCancelStyle}>Cancelar</button>
              <button onClick={aplicarAumentoMasivo} style={{ ...btnSaveStyle, backgroundColor: '#f59e0b' }}>Aplicar al precio de venta</button>
            </div>
          </div>
        </div>
      )}

      {modalImportar && datosImportacion.length > 0 && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '900px' }}>
            <h3 style={{ marginTop: 0, color: '#10b981' }}>👀 Vista Previa de Importación</h3>
            
            <div style={{ backgroundColor: '#f0fdf4', padding: '15px', borderRadius: '8px', marginBottom: '15px', border: '1px solid #bbf7d0' }}>
              <label style={{...labelStyle, color: '#16a34a'}}>Asignar un Rubro a toda la lista (Ignorando el Excel):</label>
              <select 
                style={{...inputStyle, borderColor: '#bbf7d0', marginBottom: 0}}
                onChange={(e) => {
                  const nuevaCat = e.target.value;
                  setDatosImportacion(prev => prev.map(item => ({
                    ...item,
                    categoria: nuevaCat ? nuevaCat : item.categoria_original
                  })));
                }}
              >
                <option value="">-- Mantener las categorías originales del Excel --</option>
                {categorias.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
              </select>
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto', marginBottom: '20px', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
              <table className="table-modern">
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8fafc', zIndex: 1 }}>
                  <tr><th>Acción</th><th>Código</th><th>Descripción</th><th>Marca</th><th>Rubro a Guardar</th><th>IVA</th><th style={{textAlign:'right'}}>P. Final</th></tr>
                </thead>
                <tbody>
                  {datosImportacion.map((item, idx) => (
                    <tr key={idx}>
                      <td style={{ fontWeight: 'bold', color: item.accion === 'Crear' ? '#16a34a' : '#d97706' }}>{item.accion}</td>
                      <td>{item.codigo_barras}</td><td>{item.descripcion}</td><td>{item.marca || '-'}</td>
                      <td><Badge bg="#f1f5f9" color="#475569">{item.categoria}</Badge></td>
                      <td>{item.iva_tratamiento === 'exento' ? 'Exento' : `${Number(item.iva_alicuota ?? 21).toLocaleString('es-AR')}%`}</td>
                      <td style={{textAlign:'right', fontWeight:'bold'}}>${item.precio_venta.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => { setModalImportar(false); setDatosImportacion([]); }} style={btnCancelStyle}>Descartar</button>
              <button onClick={confirmarImportacion} style={{ ...btnSaveStyle, backgroundColor: '#10b981' }}>Confirmar y Subir</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(15, 23, 42, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999 };
const modalContentStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', width: '90%', maxWidth: '600px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', boxSizing: 'border-box', maxHeight: '90vh', overflowY: 'auto' };
const btnCancelStyle = { flex: 1, padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: '#e2e8f0', color: '#475569', fontWeight: 'bold', cursor: 'pointer' };
const btnSaveStyle = { flex: 1, padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: '#3b82f6', color: 'white', fontWeight: 'bold', cursor: 'pointer' };

const Badge = ({ children, bg, color }) => <span style={{ backgroundColor: bg, color: color, padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '600' }}>{children}</span>;
const tabStyle = { background: 'none', border: 'none', padding: '10px 20px', fontSize: '15px', cursor: 'pointer', transition: 'all 0.2s' };
const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' };
const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', marginBottom: '15px', boxSizing: 'border-box' };